import type { UnwrapRef } from 'vue';
import { ref, watch } from 'vue';

export const refFromSource = <T>(selectSource: () => T) => {
	const internalValue = ref<T>(selectSource());
	const unwatch = watch(selectSource, sourceVal => {
		internalValue.value = sourceVal as UnwrapRef<T>;
	});

	return { ref: internalValue, unwatch };
};